import { FC } from 'react';
import { useTranslation } from 'next-i18next';
import { Table } from 'antd';
import styled from 'styled-components';

import { COLORS } from '@/shared/constants/colors';

import { BeneficiaryRelationsModalProps } from '../../types';
import { ModalContainerV1 } from '../interwill/containers/ModalContainerV1';

import { TableDataRow } from './types';
import { useColumnDefs } from './useColumnDefs';

export const BeneficiaryRelationsModal: FC<BeneficiaryRelationsModalProps> = ({ relations }) => {
  const { t } = useTranslation('widgets/modals', { keyPrefix: 'beneficiaryRelations' });
  const columnDefs = useColumnDefs();

  return (
    <ModalContainerV1 title={t('title')}>
      <Wrapper>
        <Text>{t('description')}</Text>
        <StyledTable<TableDataRow>
          style={{ marginTop: 24 }}
          rowKey="id"
          columns={columnDefs}
          virtual
          pagination={false}
          dataSource={relations}
        />
      </Wrapper>
    </ModalContainerV1>
  );
};

const Wrapper = styled.div`
  border-top: 1px solid ${COLORS.systemDark100};
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px;
  color: ${COLORS.systemDark300};
  overflow-y: auto;
`;

const Text = styled.p`
  font-weight: 700;
`;

const StyledTable = styled(Table)`
  margin-top: 0 !important;

  &&& {
    background-color: ${COLORS.systemLight200};
    padding: 8px 24px;
    border-radius: 16px;

    .ant-table,
    .ant-table-cell {
      background-color: transparent;
    }

    .ant-table-thead .ant-table-cell {
      color: ${COLORS.systemDark300};
    }

    .ant-table-row:last-child .ant-table-cell {
      border-bottom: none;
    }
  }
`;
